import React, { useState, useRef, useEffect } from "react";
import { Formik } from "formik";
import { Button, FormGroup, Label, Row, Col, Input } from "reactstrap";
import * as Yup from "yup";
import { cloneDeep } from "lodash";
import CoveredEntity from "components/CoveredEntity";
import NPIProviderList from "components/NPIProviderList";
import { ModuleAccess } from 'utils/moduleaccess';

const validationSchema = Yup.object({
  coveredEntityName: Yup.string().required("Please select covered entity"),
});

const providerStatusOpt = [
  { id: '', label: 'Provider Research Required' },
  { id: 'Y', label: 'Eligible' },
  { id: 'N', label: 'Ineligible' },
];

const SearchContainer = (props) => {
  const {
    filterBySearch,
    onSearch,
    onReset,
    providerFilters,
    handleUpdateEntity,
    onManualSearch,
    selectedCEId
  } = props;

  const formikRef = useRef();

  const [selectedCoveredEntity, setSelectedCoveredEntity] = useState({});
  const [selectedProvider, setSelectedProvider] = useState(null);
  const [selectedEligibleFlag, setSelectEdeligibleFlag] = useState(selectedCEId !== '' ? '' : '-1');
  const [selectedCE, setSelectedCE] = useState(selectedCEId);
  const [hasPPC, setHasPPC] = useState(false);
  useEffect(() => {
    if (providerFilters) {
      setPreValue();
    }

    if (selectedCEId) {
      setSelectEdeligibleFlag("");
    }
    setHasPPC(ModuleAccess("PRD", "PPC"));
  }, []);
  // const handleCombo = async () => {
  //   await onManualSearch();
  // }

  const onHandleManualProgram = () => {
    setOpenProgram(!isOpenProgram);
  }

  const setPreValue = () => {
    if (formikRef.current) {
      const { setFieldValue } = formikRef.current;
      const { coveredEntityName } = providerFilters;
      setFieldValue(
        "coveredEntityName",
        coveredEntityName ? parseInt(coveredEntityName) : ""
      );
    }
  };

  const handleSubmit = async (val) => {
    //const { setSubmitting } = actions;
    var values = cloneDeep(val);
    values.providerID = selectedProvider;
    values.eligibleFlag = selectedEligibleFlag;
    await onSearch(values);
    //setSubmitting(false);
  };

  const handleCoverdEntityChange = async (value, setFieldValue, entity) => {
    window.selectedCoveredEntittyId = value;
    setSelectedCE(value);
    handleUpdateEntity(entity);
    setFieldValue("coveredEntityName", value);
    setSelectedCoveredEntity(entity);
    setSelectedProvider(null);
    if (selectedCEId) {
      let param = {};
      param.coveredEntityName = value;
      await handleSubmit(param);
    }

  };

  const onSelect = (provider) => {
    setSelectedProvider(provider);
  };

  const handleReset = ({ resetForm }) => {
    resetForm();
    onReset();
    setSelectedCE("");
    setSelectedProvider(null);
    setSelectEdeligibleFlag('-1');
    window.selectedCoveredEntittyId = "";
  };

  return (
    <>
      <Formik
        innerRef={formikRef}
        initialValues={filterBySearch}
        onSubmit={handleSubmit}
        validationSchema={validationSchema}
        children={(props) => {
          const { isSubmitting, handleSubmit, resetForm, setFieldValue } =
            props;
          return (
            <div>
              <h5 className="f-15 text-primary font-weight-700">
                Search Providers
              </h5>
              <Row sm={5}>
                <Col md={2} sm={3} xs={6}>
                  {" "}
                  <FormGroup>
                    <Label for="coveredEntityID">Covered Entity</Label>
                    <CoveredEntity
                      value={selectedCE}
                      name="coveredEntityName"
                      onChange={(value, enty) =>
                        handleCoverdEntityChange(value, setFieldValue, enty)
                      }
                    />
                  </FormGroup>
                </Col>
                <Col md={2} sm={3} xs={6}>
                  <FormGroup>
                    <Label>NPI/Provider Name</Label>
                    <NPIProviderList
                      tenantID={selectedCoveredEntity.tenantID}
                      onSelect={onSelect}
                      selectedProvider={selectedProvider}
                    />
                  </FormGroup>
                </Col>

                <Col md={2} sm={3} xs={6}>
                  <FormGroup>
                    <Label>Provider Status</Label>
                    <Input
                      id="eligibleFlag"
                      name="eligibleFlag"
                      type='select'
                      value={selectedEligibleFlag}
                      onChange={(e) => {
                        setSelectEdeligibleFlag(e.target.value);
                      }}
                    >
                      <option value={'-1'}>--Select--</option>
                      {providerStatusOpt.map((status) => {
                        const { id, label } = status;
                        return (
                          <option key={id} value={id}>
                            {label}
                          </option>
                        );
                      })}
                    </Input>
                  </FormGroup>
                </Col>

                <Col md="auto" className="pt-4 mt-1">
                  <Label>{""}</Label>
                  <Button
                    disabled={isSubmitting}
                    onClick={handleSubmit}
                    color="primary"
                    className="ms-3"
                  >
                    Search
                  </Button>
                  <Button color="primary" onClick={() => handleReset(props)}>
                    Reset
                  </Button>
                  {/* <Button disabled={!selectedCE}
                    onClick={handleCombo}
                    color="primary"
                    className="ms-3"
                    hidden={!hasPPC}
                  >
                    Auto-Approve Prov. & Pt. Combo

                  </Button> */}
                </Col>
              </Row>
            </div>
          );
        }}
      ></Formik>
    </>
  );
};

export default SearchContainer;
